import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { RefreshChannel } from '@utils/enums';

interface RefreshState {
  [RefreshChannel.Inventory]: number;
  [RefreshChannel.ProductVersion]: number;
}

const initialState: RefreshState = {
  [RefreshChannel.Inventory]: 0,
  [RefreshChannel.ProductVersion]: 0,
};

export const RefreshStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => {
    return {
      trigger(channel: RefreshChannel) {
        patchState(store, (state) => ({
          [channel]: state[channel] + 1,
        }));
      },
    };
  }),
);
